import { useLocation } from 'react-router-dom'
import moment from 'moment'
import './verify.scss'
import { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import LibraryAssetUploader from '../../services/library-assets/LibraryAssetUploader'
import * as UploadServices from '../../services/UploadServices'
import { toast } from 'react-toastify'
import Spinner from '../../components/common/spinner/Spinner'
import FileUtils from '../../utils/FileUtils'
import instance from '../../utils/Axios'
import Header from '../../components/header/Header'
import SignUpModal from '../main/landing-page/SignUp'
import SignInModal from '../main/landing-page/SignIn'
import { Footer } from '../../components/footer/Footer'
import { c2paRead } from '../../services/c2pa/C2paService'
import VerifyViewPage from './VerifyViewPage'
import VerifyUploadSection from './VerifyUploadSection'

const FILE_UPLOAD_SIZE_LIMIT = 2123138000

const Verify = () => {
  const inputRef = useRef(null)
  const location = useLocation()
  const [uploading, setUploading] = useState(false)
  const [verifiedData, setVerifiedData] = useState()
  const [isSignUpOpen, setIsSignUpOpen] = useState(false)
  const [isSignInOpen, setIsSignInOpen] = useState(false)
  const [assetVerifying, setAssetVerifying] = useState(null)

  const uploadMedia = () => {
    inputRef.current.click()
  }

  const verifyMedia = async (e) => {
    try {
      setUploading(true)
      setVerifiedData()
      const files = e.target.files
      if (_.isEmpty(files)) {
        return
      }

      const file = _.first(files)
      if (file.size > FILE_UPLOAD_SIZE_LIMIT) {
        return toast.error(
          'Whoa! That is a huge file size. It exceeds our max 5 GB limit. Try something smaller.',
        )
      }

      const fileName = file.name

      const fileExt = fileName.substring(fileName.lastIndexOf('.'))
      const fileNameUrl = `${moment().format('x')}${fileExt}`

      const uploadData = await LibraryAssetUploader.saveAsLibraryAsset(
        file,
        fileNameUrl,
        `assets/${FileUtils.getFileType(file.type)}s`,
        'verify',
      )
      let returnVerifyData = {}
      setAssetVerifying(uploadData.location)

      const c2paData = await c2paRead(uploadData.location)
      returnVerifyData = { ...returnVerifyData, ...c2paData }

      if (!returnVerifyData.license) {
        const verifyData = await UploadServices.verifyMedia({
          url: uploadData.location,
        })
        returnVerifyData = { ...returnVerifyData, ...verifyData }
      }

      if (!returnVerifyData?.appUsed) throw new Error('Not found')

      setVerifiedData(returnVerifyData)
      setUploading(false)
    } catch (error) {
      setUploading(false)
      toast.error(
        'Unfortunately, we can not retrieve the licensing information associated with this asset, if you beleive it was processed by TikBox, contact customer support.',
      )
    }
  }

  const verifyMediaByAssetId = async (assetId) => {
    try {
      setUploading(true)
      setVerifiedData()
      const verifiedData = await instance.get(`/assets/${assetId}/verify`)

      if (!verifiedData?.data?.signing) {
        throw new Error('Not found')
      }
      setVerifiedData(verifiedData?.data?.signing)
      setUploading(false)
    } catch (error) {
      setUploading(false)
      toast.error(
        'Unfortunately, we can not retrieve the licensing information associated with this asset, if you beleive it was processed by TikBox, contact customer support.',
      )
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const assetId = queryParams.get('assetId')
    if (assetId) {
      verifyMediaByAssetId(assetId)
    }
  }, [])

  return (
    <>
      <Header
        setIsSignUpOpen={setIsSignUpOpen}
        setIsSignInOpen={setIsSignInOpen}
      />
      <div className="tikbox-verify">
        {uploading && <Spinner />}
        <div className="tikbox-verify__content">
          {!verifiedData && (
            <VerifyUploadSection
              uploadMedia={uploadMedia}
              verifyMedia={verifyMedia}
              inputRef={inputRef}
            />
          )}
          {verifiedData && (
            <VerifyViewPage
              assetVerifying={assetVerifying}
              verifiedData={verifiedData}
            />
          )}
        </div>
      </div>
      {isSignUpOpen && (
        <SignUpModal
          setIsSignUpOpen={setIsSignUpOpen}
          setIsSignInOpen={setIsSignInOpen}
        />
      )}
      {isSignInOpen && (
        <SignInModal
          setIsSignUpOpen={setIsSignUpOpen}
          setIsSignInOpen={setIsSignInOpen}
        />
      )}
      <Footer />
    </>
  )
}

export default Verify
